import api from "./api";

export const loginUser = (data) => {

    return api.post("/auth/login", data);

};

export const registerUser = (data) => {

    return api.post("/auth/register", data);

};
export const getProfile = () =>
    api.get("/auth/me");

export const updateProfile = (data) =>
    api.put("/auth/me", data);

export const changePassword = (data) =>
    api.put("/auth/change-password", data);

export const forgotPassword = (email) =>
    api.post("/auth/forgot-password", { email });

export const resetPassword = (token, newPassword) =>
    api.post("/auth/reset-password", { token, newPassword });
